/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SddMandate } from './SddMandate';
import {
    SddMandateFromJSON,
    SddMandateFromJSONTyped,
    SddMandateToJSON,
} from './SddMandate';

/**
 * 
 * @export
 * @interface AccountMandatsOutput
 */
export interface AccountMandatsOutput {
    /**
     * List of documents that changed since the entry date
     * @type {Array<SddMandate>}
     * @memberof AccountMandatsOutput
     */
    mandates?: Array<SddMandate>;
    /**
     * 
     * @type {Error}
     * @memberof AccountMandatsOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the AccountMandatsOutput interface.
 */
export function instanceOfAccountMandatsOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AccountMandatsOutputFromJSON(json: any): AccountMandatsOutput {
    return AccountMandatsOutputFromJSONTyped(json, false);
}

export function AccountMandatsOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountMandatsOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mandates': !exists(json, 'mandates') ? undefined : ((json['mandates'] as Array<any>).map(SddMandateFromJSON)),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function AccountMandatsOutputToJSON(value?: AccountMandatsOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mandates': value.mandates === undefined ? undefined : ((value.mandates as Array<any>).map(SddMandateToJSON)),
        'error': value.error,
    };
}

